import styled from 'styled-components';
import {basicColor, font, radius} from '../../../../styles/template';

export const NumberWrap = styled.div`
    &.number {
      display: flex;
      align-items: center;
      height: 7rem;

      & > * {
        height: 100%;
      }

      & > :first-child, & > :last-child {
        width: 7rem;
        flex-shrink: 0;
      }
      
      & > .disabled svg > :first-child {
        stroke: none !important;
        fill: none !important;
      }

      & > .disabled svg > .colorFill {
        stroke: none !important;
      }

      & > :first-child {
        border-radius: 5px 0 0 5px;
      }

      & > :last-child {
        border-radius: 0 5px 5px 0;
      }

      & > :nth-child(2) {
        border-radius: 0;
        flex-grow: 1;
      }
    }
`;

export const TestingInput = styled.input`
	width: 100%;
	height: 7rem;
	background: ${basicColor.white};
	${font.basic};
	color: ${basicColor.deepDark};
	border-radius: ${radius.normal};
	padding: 0 2rem;
	
	&.isError {
		border: 1px solid ${basicColor.red};
	}

	&.isCorrect {
		border: 1px solid ${basicColor.secondary};
	}
	
	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
		pointer-events: all !important;
	}
`;
